import React, { Component } from 'react';
import TextWithFieldname from '../texts/TextWithFieldname';
import Dico from '../../helpers/Dico'
import CalculatorContentClassical from './CalculatorContentClassical';
import CalculatorContentSvcLevels from './CalculatorContentSvcLevels';

class Calculator extends Component {

    handleUpdate() {
        this.props.onUpdate(this.props.parameters, this.props.customer);
    }
    handleModeChange = (event, calculatorMode) => {
        this.props.onChangeMode(calculatorMode);
    };

    render() {
        const calculationResponse = this.props.simulationDetails;
        const isCalculationResult = calculationResponse && !calculationResponse.hasError && calculationResponse.result;
        return (
            <React.Fragment>
                <div className='modal' id='modalCalculator' tabIndex="-1" aria-labelledby="modalCalculatorTitle">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header border-0" >
                                <div className="container-fluid">
                                    <button type="button" className="btn-close float-end" data-bs-dismiss="modal" aria-label="Close" onMouseDown={(e) => e.currentTarget.blur()}></button>
                                    <div className="float-end text-start">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="flexRadioCalculatorMode" id='flexRadioCalculatorModeCLASSICAL'
                                                checked={this.props.calculatorMode === 'CLASSICAL'}
                                                onChange={event => { this.handleModeChange(event, 'CLASSICAL') }}
                                            />
                                            <label className="form-check-label" htmlFor='flexRadioCalculatorModeCLASSICAL'>
                                                {Dico.getMessage(this.props.context.countryCode, this.props.settings.actualLanguage, 'calculatorPage.mode.CLASSICAL')}
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="flexRadioCalculatorMode" id='flexRadioCalculatorModeSVCLEVEL'
                                                checked={this.props.calculatorMode === 'SVCLEVEL'}
                                                onChange={event => { this.handleModeChange(event, 'SVCLEVEL') }}
                                            />
                                            <label className="form-check-label" htmlFor='flexRadioCalculatorModeSVCLEVEL'>
                                                {Dico.getMessage(this.props.context.countryCode, this.props.settings.actualLanguage, 'calculatorPage.mode.SVCLEVEL')}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row shadow rounded text-center m-auto">
                                        {isCalculationResult && calculationResponse.result.globalText
                                            && <TextWithFieldname fieldname="detailTitle" variant="h5"
                                                    developperView={this.props.settings.isDevelopperView} idTitle="modalCalculatorTitle">
                                                {calculationResponse.result.globalText.detailTitle != null ?
                                                    calculationResponse.result.globalText.detailTitle :
                                                    Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, 'detailPage.result.title')}
                                            </TextWithFieldname>
                                        }
                                        {isCalculationResult && calculationResponse.result.globalText
                                            && <TextWithFieldname fieldname="detailSubTitle" variant="h6" developperView={this.props.settings.isDevelopperView}>
                                                {calculationResponse.result.globalText.detailSubTitle}
                                            </TextWithFieldname>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="row p-1 m-1 text-center">
                                    <div className="row shadow rounded text-start">
                                        <div className="row">
                                            <div className="col-8">
                                                {this.props.vehicle && this.props.vehicle.presentation != null &&
                                                    <h6>
                                                        {this.props.vehicle.presentation.logo && this.props.vehicle.presentation.logo.trim() !== '' &&
                                                            <img src={this.props.vehicle.presentation.logo} height="45" alt={this.props.vehicle.presentation.longLabel} />
                                                        }
                                                        {this.props.vehicle.presentation.longLabel}
                                                    </h6>
                                                }
                                            </div>
                                            <div className="col">
                                                {isCalculationResult
                                                    && calculationResponse.result.globalText != null
                                                    && calculationResponse.result.globalText.validityText != null
                                                    && calculationResponse.result.globalText.validityText.map((line, index) => (
                                                        <p className="text-end" key={index}>{line.text}</p>
                                                    ))}
                                            </div>
                                        </div>
                                        <div className="row">
                                            {isCalculationResult
                                                && calculationResponse.result.globalText != null
                                                && calculationResponse.result.globalText.legalNotice != null
                                                && calculationResponse.result.globalText.legalNotice.map((line, index) => (
                                                    <p className="text-end fs-5" key={index}>{line.text}</p>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                                {this.props.calculatorMode === 'CLASSICAL' && <CalculatorContentClassical
                                    context={this.props.context}
                                    vehicle={this.props.vehicle}
                                    isCalculationResult={isCalculationResult}
                                    calculationResponse={calculationResponse}
                                    onUpdateCriteria={() => { this.handleUpdate() }}
                                />}
                                {this.props.calculatorMode === 'SVCLEVEL' && <CalculatorContentSvcLevels
                                    context={this.props.context}
                                    vehicle={this.props.vehicle}
                                    isCalculationResult={isCalculationResult}
                                    calculationResponse={calculationResponse}
                                    onUpdateCriteria={() => { this.handleUpdate() }}
                                />}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal' id="modalCalculatorService" tabIndex="-1" aria-labelledby="modalCalculatorServiceTitle">
                    <div className="modal-dialog">
                        {this.props.infoService && this.props.infoService.info != null && this.props.infoService.info.length !== 0 &&
                            <div className="modal-content">
                                <div className="modal-header border-0" >
                                    <div className="container-fluid">
                                        <h6 id="modalCalculatorServiceTitle">{this.props.infoService.label}</h6>
                                    </div>
                                </div>
                                <div className="container-fluid text-center">
                                    <div className="row">
                                        {this.props.infoService.info}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div >
            </React.Fragment>
        );
    }
}

export default (Calculator)
